<template>
	<div>
		<SOSlotModal
			v-if="!pageSetting.loading"
			:modal-id="pageSetting.modal.id"
			:modal-title="pageSetting.modal.title"
			@close="close"
		>
			<template v-slot:modal-body>
				<div style="max-height: 400px; overflow-y: auto">
					<div class="f-bold f-18 f-c-black m-d-8">
						{{ namaLayanan }}
					</div>

					<div class="m-d-16">
						<div class="f-regular f-13 f-c-midgrey" v-if="minimalOrderTransaksi > 0">
							<svg width="16" height="16" viewBox="0 0 16 16" fill="none"
							     xmlns="http://www.w3.org/2000/svg">
								<path fill-rule="evenodd" clip-rule="evenodd"
								      d="M4.00008 2.66669H12.0001C12.7365 2.66669 13.3334 3.26364 13.3334 4.00002V12C13.3334 12.7364 12.7365 13.3334 12.0001 13.3334H4.00008C3.2637 13.3334 2.66675 12.7364 2.66675 12V4.00002C2.66675 3.26364 3.2637 2.66669 4.00008 2.66669ZM8.00007 4.66664C7.63188 4.66664 7.33341 4.96512 7.33341 5.33331C7.33341 5.7015 7.63188 5.99998 8.00007 5.99998H8.00541C8.3736 5.99998 8.67207 5.7015 8.67207 5.33331C8.67207 4.96512 8.3736 4.66664 8.00541 4.66664H8.00007ZM7.33341 7.33333C6.96522 7.33333 6.66675 7.63181 6.66675 8C6.66675 8.36819 6.96522 8.66666 7.33341 8.66666V10.6667C7.33341 11.0349 7.63189 11.3333 8.00008 11.3333H8.66675C9.03494 11.3333 9.33341 11.0349 9.33341 10.6667C9.33341 10.2985 9.03494 10 8.66675 10L8.66675 8C8.66675 7.63181 8.36827 7.33333 8.00008 7.33333H7.33341Z"
								      fill="#6F7287"/>
							</svg>
							Minimal order transaksi {{ minimalOrderTransaksi }} {{ satuan }}
						</div>
						<div class="f-regular f-13 f-c-midgrey" v-if="minimalOrderDeposit > 0">
							<svg width="16" height="16" viewBox="0 0 16 16" fill="none"
							     xmlns="http://www.w3.org/2000/svg">
								<path fill-rule="evenodd" clip-rule="evenodd"
								      d="M4.00008 2.66669H12.0001C12.7365 2.66669 13.3334 3.26364 13.3334 4.00002V12C13.3334 12.7364 12.7365 13.3334 12.0001 13.3334H4.00008C3.2637 13.3334 2.66675 12.7364 2.66675 12V4.00002C2.66675 3.26364 3.2637 2.66669 4.00008 2.66669ZM8.00007 4.66664C7.63188 4.66664 7.33341 4.96512 7.33341 5.33331C7.33341 5.7015 7.63188 5.99998 8.00007 5.99998H8.00541C8.3736 5.99998 8.67207 5.7015 8.67207 5.33331C8.67207 4.96512 8.3736 4.66664 8.00541 4.66664H8.00007ZM7.33341 7.33333C6.96522 7.33333 6.66675 7.63181 6.66675 8C6.66675 8.36819 6.96522 8.66666 7.33341 8.66666V10.6667C7.33341 11.0349 7.63189 11.3333 8.00008 11.3333H8.66675C9.03494 11.3333 9.33341 11.0349 9.33341 10.6667C9.33341 10.2985 9.03494 10 8.66675 10L8.66675 8C8.66675 7.63181 8.36827 7.33333 8.00008 7.33333H7.33341Z"
								      fill="#6F7287"/>
							</svg>
							Minimal order deposit {{ minimalOrderDeposit }} {{ satuan }}
						</div>
						<div class="f-regular f-13 f-c-midgrey" v-if="isRegulerSnapbridge">
							<svg width="16" height="16" viewBox="0 0 16 16" fill="none"
							     xmlns="http://www.w3.org/2000/svg">
								<path fill-rule="evenodd" clip-rule="evenodd"
								      d="M4 2.00008C3.63181 2.00008 3.33333 2.29856 3.33333 2.66675V13.3334C3.33333 13.7016 3.63181 14.0001 4 14.0001H12C12.3682 14.0001 12.6667 13.7016 12.6667 13.3334V2.66675C12.6667 2.29856 12.3682 2.00008 12 2.00008H4ZM2 2.66675C2 1.56218 2.89543 0.666748 4 0.666748H12C13.1046 0.666748 14 1.56218 14 2.66675V13.3334C14 14.438 13.1046 15.3334 12 15.3334H4C2.89543 15.3334 2 14.438 2 13.3334V2.66675ZM7.99965 5.66669C6.89508 5.66669 5.99965 6.56212 5.99965 7.66669C5.99965 8.77126 6.89508 9.66669 7.99965 9.66669C9.10422 9.66669 9.99965 8.77126 9.99965 7.66669C9.99965 6.56212 9.10422 5.66669 7.99965 5.66669ZM4.66632 7.66669C4.66632 5.82574 6.1587 4.33336 7.99965 4.33336C9.8406 4.33336 11.333 5.82574 11.333 7.66669C11.333 9.50764 9.8406 11 7.99965 11C6.1587 11 4.66632 9.50764 4.66632 7.66669Z"
								      fill="#6F7287"/>
							</svg>
							{{ jenisRegulerSnapbridge }}
						</div>
					</div>
					<div class="separator-line m-d-16"></div>

					<div class="m-d-16">
						<div class="row m-0 m-d-4">
							<div class="col-4 p-0 f-regular f-14 f-c-midgrey">
								Kuantitas
							</div>
							<div class="col-8 p-0 f-regular f-14">
								<span class="f-c-black">{{ formatRupiah(kuantitas) }} {{ satuan }} </span>
								<span v-if="siklusMesin > 0" class="f-c-midgrey">({{
										siklusMesin
									}}x siklus mesin)</span>
							</div>
						</div>
						<div class="row m-0 m-d-4">
							<div class="col-4 p-0 f-regular f-14 f-c-midgrey">
								Harga
							</div>
							<div class="col-8 p-0 f-regular f-14">
								<span class="f-c-black"> {{ hargaLayananTotal }} </span>
								<span class="f-c-midgrey"> {{ hargaLayanan }}/{{ satuan }}) </span>
							</div>
						</div> 
						<div class="row m-0 m-d-4"
						     v-if="luas > 0">
							<div class="col-4 p-0 f-regular f-14 f-c-midgrey">
								Luas
							</div>
							<div class="col-8 p-0 f-regular f-14 f-c-black">
								{{ formatRupiah(luas) }} sebanyak {{ kuantitasLuas }} {{ satuan }}
							</div>
						</div>
						<div class="row m-0 m-d-4" v-if="listDetItem.length > 0">
							<div class="col-4 p-0 f-regular f-14 f-c-midgrey">
								Item
							</div>
							<div class="col-8 p-0 f-regular f-14 f-c-black">
								<span v-for="(detitem, i) in listDetItem" :key="i">
									{{ detitem.jumlah_item }} {{ detitem.item.nama }}<span
									v-if="i !== listDetItem.length - 1">, </span>
								</span>
							</div>
						</div>
						<div class="row m-0" v-if="false">
							<div class="col-4 p-0 f-regular f-14 f-c-midgrey">
								Warna
							</div>
							<div class="col-8 p-0 f-regular f-14 f-c-black">
								Merah, Kuning
							</div>
						</div>
					</div>
					<div class="separator-line m-d-16"></div>

					<div class="f-regular f-14 f-c-midgrey m-d-4" v-if="listMesinCuci.length > 0">
						— Mesin cuci
					</div>
					<div class="m-d-16"
					     v-for="mesinCuci in listMesinCuci">
						<div v-if="mesinCuci.status === 1">
							<div class="f-regular f-14 f-c-midgrey">
								Belum dikerjakan.
							</div>
						</div>
						<div v-else>
							<div class="row m-0 m-d-4">
								<div class="col-4 p-0 f-regular f-14 f-c-midgrey">
									Mesin
								</div>
								<div class="col-8 p-0 f-regular f-14 f-c-black">
									{{ mesinCuci.snap_mesin.nama }}
								</div>
							</div>
							<div class="row m-0 m-d-4">
								<div class="col-4 p-0 f-regular f-14 f-c-midgrey">
									Mulai
								</div>
								<div class="col-8 p-0 f-regular f-14 f-c-black">
									{{ $moment(mesinCuci.start_at).format("DD MMM YYYY HH:mm") }}
								</div>
							</div>
							<div class="row m-0 m-d-4" v-if="mesinCuci.status === 3">
								<div class="col-4 p-0 f-regular f-14 f-c-midgrey">
									Status
								</div>
								<div class="col-8 p-0 f-regular f-14 f-c-black">
									<span class="spinner-border spinner-border-sm f-c-midgrey m-r-12"
									      role="status"
									      aria-hidden="true"
									></span>
									<span class="f-regular f-14 f-c-black">Sedang dikerjakan...</span>
								</div>
							</div>
							<div class="row m-0 m-d-4">
								<div class="col-4 p-0 f-regular f-14 f-c-midgrey">
									Selesai
								</div>
								<div class="col-8 p-0 f-regular f-14 f-c-black">
									{{ $moment(mesinCuci.stop_at).format("DD MMM YYYY HH:mm") }}
								</div>
							</div>
							<div class="row m-0">
								<div class="col-4 p-0 f-regular f-14 f-c-midgrey">
									Petugas
								</div>
								<div class="col-8 p-0 f-regular f-14 f-c-black">
									{{ mesinCuci.karyawan.nama }}
								</div>
							</div>
						</div>
					</div>
					<div v-if="listMesinCuci.length > 0" class="separator-line m-d-16"></div>

					<div class="f-regular f-14 f-c-midgrey m-d-4" v-if="listMesinPengering.length > 0">
						— Mesin pengering
					</div>
					<div class="m-d-16"
					     v-for="mesinPengering in listMesinPengering">
						<div v-if="mesinPengering.status === 1">
							<div class="f-regular f-14 f-c-midgrey">
								Belum dikerjakan.
							</div>
						</div>
						<div v-else>
							<div class="row m-0 m-d-4">
								<div class="col-4 p-0 f-regular f-14 f-c-midgrey">
									Mesin
								</div>
								<div class="col-8 p-0 f-regular f-14 f-c-black">
									{{ mesinPengering.snap_mesin.nama }}
								</div>
							</div>
							<div class="row m-0 m-d-4">
								<div class="col-4 p-0 f-regular f-14 f-c-midgrey">
									Mulai
								</div>
								<div class="col-8 p-0 f-regular f-14 f-c-black">
									{{ $moment(mesinPengering.start_at).format("DD MMM YYYY HH:mm") }}
								</div>
							</div>
							<div class="row m-0 m-d-4" v-if="mesinPengering.status === 3">
								<div class="col-4 p-0 f-regular f-14 f-c-midgrey">
									Status
								</div>
								<div class="col-8 p-0 f-regular f-14 f-c-black">
									<span class="spinner-border spinner-border-sm f-c-midgrey m-r-12"
									      role="status"
									      aria-hidden="true"
									></span>
									<span class="f-regular f-14 f-c-black">Sedang dikerjakan...</span>
								</div>
							</div>
							<div class="row m-0 m-d-4">
								<div class="col-4 p-0 f-regular f-14 f-c-midgrey">
									Selesai
								</div>
								<div class="col-8 p-0 f-regular f-14 f-c-black">
									{{ $moment(mesinPengering.stop_at).format("DD MMM YYYY HH:mm") }}
								</div>
							</div>
							<div class="row m-0">
								<div class="col-4 p-0 f-regular f-14 f-c-midgrey">
									Petugas
								</div>
								<div class="col-8 p-0 f-regular f-14 f-c-black">
									{{ mesinPengering.karyawan.nama }}
								</div>
							</div>
						</div>
					</div>
					<div v-if="listMesinPengering.length > 0" class="separator-line m-d-16"></div>

					<div class="m-d-16" v-if="detail.data.main_data.keterangan !== ''">
						<div class="f-regular f-14 f-c-midgrey">
							Catatan
						</div>
						<div class="f-regular f-14 f-c-black">
							{{ detail.data.main_data.keterangan }}
						</div>
					</div>
					<div class="separator-line m-d-16" v-if="detail.data.main_data.keterangan !== ''"></div>

					<div class="m-d-16" v-if="detail.data.transaksi_foto.length > 0">
						<div class="f-regular f-14 f-c-midgrey">
							Dokumentasi barang
						</div>
						<div>
							<div class="d-flex flex-wrap-reverse" v-if="images.length > 0">
								<div v-for="foto in images">
									<div
										v-if="foto.cloud_thumb === null"
										class="m-1"
										style="height: 52px; width: 52px; border-radius: 4px; background-position: center; background-size: cover"
										:style="{backgroundImage: 'url(' + baseUrlCloudBucket + foto.cloud_bucket + '/' + foto.cloud_name +')'}"
										@click="previewPhoto(baseUrlCloudBucket + foto.cloud_bucket + '/' + foto.cloud_name, foto.cloud_content_type)"
									>
									</div>
									<div
										v-else
										class="m-1"
										style="height: 52px; width: 52px; border-radius: 4px; background-position: center; background-size: cover"
										:style="{backgroundImage: 'url(' + baseUrlCloudBucket + foto.cloud_bucket + '/' + foto.cloud_thumb +')'}"
										@click="previewPhoto(baseUrlCloudBucket + foto.cloud_bucket + '/' + foto.cloud_name, foto.cloud_content_type)"
									>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</template>
		</SOSlotModal>

		<div class="modal" tabindex="-1" role="dialog" :id="modalId">
			<div class="modal-dialog m-0" role="document">
				<div class="modal-content" style="border-radius: 0">
					<div
						class="modal-body p-0 vh-100 d-flex justify-content-center align-items-center"
						style="background-color: black;">
						<img src="@/assets/icons/close-white.svg" alt=""
						     style="position:absolute; top: 20px; left: 20px; border-radius: 50%; background-color: #00000080"
						     @click="previewPhotoClose"
						>
						<iframe v-if="fileContentType.includes('video')" style="width: 100vw; height: 100vh"
						        :src="fileUrl" title="description"></iframe>
						<img v-else :src="fileUrl" class="w-100" alt="">
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {mapGetters} from "vuex";
import SOSlotModal from "@/so-components/global/slot/SOSlotModal";

export default {
	name: "TransaksiModalDetailLayanan",
	components: {
		SOSlotModal,
	},
	props: {
		idtransaksi: {
			type: String,
			default: "",
		},
		iddetlayanan: {
			type: String,
			default: "",
		},
	},
	computed: {
		...mapGetters("transaksiModule", {
			detail: "getDetailLayananTransaksi",
		}),
		isRegulerSnapbridge() {
			return this.detail.data.main_data.detlayanan_snap.length > 0
		},
		jenisRegulerSnapbridge() {
			if (this.listMesinCuci.length > 0 && this.listMesinPengering.length > 0) {
				return "Mesin Snapbridge Cuci & Pengering"
			} else if (this.listMesinCuci.length > 0) {
				return "Mesin Snapbridge Cuci"
			} else if (this.listMesinPengering.length > 0) {
				return "Mesin Snapbridge Pengering"
			}
		},
		listMesinCuci() {
			return this.detail.data.main_data.detlayanan_snap.filter(v => v.idtahapan === 5000)
		},
		listMesinPengering() {
			return this.detail.data.main_data.detlayanan_snap.filter(v => v.idtahapan === 6000)
		},

		// data
		namaLayanan() {
			return this.detail.data.main_data.data_layanan.nama_layanan
		},
		hargaLayanan() {
			let harga = this.detail.data.main_data.harga
			return `(@Rp. ${this.formatRupiah(harga)}`
		},
		hargaLayananTotal() {
			let harga = this.detail.data.main_data.hargatotal
			return `Rp. ${this.formatRupiah(harga)}`
		},
		minimalOrderTransaksi() {
			return this.detail.data.main_data.harga_layanan.min_order_reg
		},
		minimalOrderDeposit() {
			return this.detail.data.main_data.harga_layanan.min_order_depo
		},
		satuan() {
			return this.detail.data.main_data.data_layanan.satuan.nama
		},
		kuantitas() {
			return this.detail.data.main_data.JumlahBeli
		},
		siklusMesin() {
			return this.detail.data.main_data.total_load
		},
		luas() {
			return this.detail.data.main_data.luas_p * this.detail.data.main_data.luas_l
		},
		kuantitasLuas() {
			return this.detail.data.main_data.luas_q
		},
		listDetItem() {
			return this.detail.data.main_data.detitem
		},
		images() {
			return this.detail.data.transaksi_foto
		}
	},
	data() {
		return {
			pageSetting: {
				modal: {
					id: "detail-layanan",
					title: "Detail Layanan",
				},
				loading: true,
			},
			baseUrlCloudBucket: "https://storage.googleapis.com/",
			fileUrl: "",
			fileContentType: "",
			modalId: "modal-preview-" + Math.floor(Math.random() * 10000).toString(),
		}
	},
	mounted() {
		this.getDetailLayananTransaksi()
	},
	methods: {
		async getDetailLayananTransaksi() {
			const res = await this.$store.dispatch("transaksiModule/fetchDetailLayananTransaksi", {
				idtransaksi: this.idtransaksi,
				iddetlayanan: this.iddetlayanan,
			})
			this.pageSetting.loading = false
			if (!res.success) {
				this.$toast.error(res.err)
				this.$router.back()
				return
			}
			setTimeout(() => {
				$("#" + this.pageSetting.modal.id).modal("show");
			}, 500)
		},
		close() {
			$("#" + this.pageSetting.modal.id).modal("hide");
			setTimeout(() => {
				this.$emit("close")
			}, 500)
		},
		previewPhoto(selectedPhoto, contentType) {
			$("#" + this.pageSetting.modal.id).modal("hide");

			setTimeout(() => {
				this.fileUrl = selectedPhoto
				this.fileContentType = contentType
				$("#" + this.modalId).modal("show")
			}, 200)
		},
		previewPhotoClose() {
			$("#" + this.modalId).modal("hide")
			this.fileUrl = ""
			this.fileContentType = ""
			setTimeout(() => {
				$("#" + this.pageSetting.modal.id).modal("show");
			}, 200)
		}
	}
}
</script>